/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskIndicatorType } from './RiskIndicatorType';
import {
  RiskIndicatorTypeFromJSON,
  RiskIndicatorTypeFromJSONTyped,
  RiskIndicatorTypeToJSON,
} from './RiskIndicatorType';

/**
 *
 * @export
 * @interface PaginatedRiskIndicatorTypeList
 */
export interface PaginatedRiskIndicatorTypeList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRiskIndicatorTypeList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskIndicatorTypeList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskIndicatorTypeList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RiskIndicatorType>}
   * @memberof PaginatedRiskIndicatorTypeList
   */
  results: Array<RiskIndicatorType>;
}

/**
 * Check if a given object implements the PaginatedRiskIndicatorTypeList interface.
 */
export function instanceOfPaginatedRiskIndicatorTypeList(value: object): value is PaginatedRiskIndicatorTypeList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRiskIndicatorTypeListFromJSON(json: any): PaginatedRiskIndicatorTypeList {
  return PaginatedRiskIndicatorTypeListFromJSONTyped(json, false);
}

export function PaginatedRiskIndicatorTypeListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRiskIndicatorTypeList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RiskIndicatorTypeFromJSON),
  };
}

export function PaginatedRiskIndicatorTypeListToJSON(value?: PaginatedRiskIndicatorTypeList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RiskIndicatorTypeToJSON),
  };
}
